import { MessageSquareHeart, Lightbulb, Wrench, Handshake } from "lucide-react";
import { Reveal } from "./Section";
import { EmailSetupButton, MailLine } from "./EmailCta";

const POINTS = [
  [Lightbulb, "Tell us what works — and what doesn't"],
  [Wrench, "Ask for the features your crew needs"],
  [Handshake, "Get set up with a hand from us"],
];

// Honest "we're new" band asking real crews for feedback.
export const EarlyDays = ({ onFeedback }) => (
  <section id="feedback" className="scroll-mt-16 relative overflow-hidden bg-[#1E3A5F] text-white" data-testid="home-feedback">
    <div className="absolute inset-0 home-grid opacity-40" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24 grid lg:grid-cols-[1.2fr_1fr] gap-12 items-center">
      <Reveal>
        <p className="font-mono text-xs font-semibold tracking-[0.2em] uppercase text-[#FDBA74]">We&apos;re new</p>
        <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]" data-testid="home-feedback-title">
          Built with real crews. <span className="text-[#FDBA74]">Help us shape it.</span>
        </h2>
        <p className="mt-5 text-base md:text-lg text-slate-300 leading-relaxed max-w-xl">
          Cross Jobs is a new Australian business and we want real-world feedback. Tell us how you run your jobs, what&apos;s missing and what would make your week easier — we&apos;ll build around your needs.
        </p>
        <div className="mt-9 flex flex-wrap gap-3">
          <EmailSetupButton testid="home-feedback-email-btn" label="Email us today" />
          <button onClick={onFeedback} data-testid="home-feedback-btn"
            className="inline-flex items-center gap-2 rounded-full border border-white/30 px-7 py-3.5 font-semibold hover:bg-white hover:text-[#1E3A5F] transition-colors">
            <MessageSquareHeart className="w-4 h-4" /> Give feedback
          </button>
        </div>
        <div className="mt-5"><MailLine testid="home-feedback-mail" /></div>
      </Reveal>
      <Reveal delay={0.1}>
        <ul className="space-y-3">
          {POINTS.map(([Icon, t], i) => (
            <li key={t} className="flex items-center gap-4 rounded-2xl bg-white/5 border border-white/10 p-5 backdrop-blur-sm" data-testid={`home-feedback-point-${i}`}>
              <span className="w-11 h-11 shrink-0 rounded-xl bg-[#EA580C] grid place-items-center"><Icon className="w-5 h-5" /></span>
              <span className="font-display text-base sm:text-lg font-bold">{t}</span>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
